import {ReactElement, useState, ReactNode} from 'react'
import {Trans} from 'react-i18next'

import {ContactSupportModal} from './ContactSupportModal'
import messages from '../../../../../assets/messages'
import {useStyles} from './styles'
import {RefundWithdrawSchemaItem} from '../types'

type RefundInformationProps = {
  accountId: number,
  clientId: number,
  additionalItems?: ReactNode,
  refundWithdrawSchema: RefundWithdrawSchemaItem[],
  onlySelectPaymentMethodFlow: boolean,
  onDepositMethodVerificationSubmittedModalOpen: () => void,
}

function RefundInformation(props: RefundInformationProps): ReactElement {
  const classes = useStyles()
  const {
    accountId,
    additionalItems,
    clientId,
    refundWithdrawSchema,
    onlySelectPaymentMethodFlow,
    onDepositMethodVerificationSubmittedModalOpen,
  } = props
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false)

  const handleSupportModalOpen = () => setIsSupportModalOpen(true)
  const handleSupportModalClose = () => setIsSupportModalOpen(false)

  return (
    <>
      <ContactSupportModal
        accountId={accountId}
        clientId={clientId}
        isOpen={isSupportModalOpen}
        refundWithdrawSchema={refundWithdrawSchema}
        onlySelectPaymentMethodFlow={onlySelectPaymentMethodFlow}
        onClose={handleSupportModalClose}
        onDepositMethodVerificationSubmittedModalOpen={onDepositMethodVerificationSubmittedModalOpen}
      />
      <div className={classes.container}>
        <div className={classes.title}>
          <Trans {...messages.importantRefundInformation} />:
        </div>
        <ul className={classes.list}>
          {additionalItems}
          <li>
            <Trans
              {...messages.importantRefundInformationPoint1}
              components={[<button className={classes.button} onClick={handleSupportModalOpen}>button</button>]}
            />
          </li>
          <li><Trans {...messages.importantRefundInformationPoint2} /></li>
        </ul>
      </div>
    </>
  )
}

export {RefundInformation}
